import { onRestreamingStoppedSaga } from 'features/restreamer/sagas/onRestreamingStoppedSaga';
import { toggleRestreamingSaga } from 'features/restreamer/sagas/toggleRestreamingSaga';
import { takeLatest } from 'redux-saga/effects';
import { stopRestreamingRequest } from 'features/restreamer/restreamerSlice';
import { requestRestreamingSaga } from 'features/restreamer/sagas/requestRestreamingSaga';
import {
  requestRestreaming,
  restreamingToggled,
  signalingRestreamerJoined,
  signalingRestreamingFailure,
  signalingRestreamingRequested,
  signalingRestreamingStarted,
  signalingRestreamingStopped,
  signalingRestreamingStopRequested,
} from 'features/restreamer/actions';
import { onRestreamingStartedSaga } from 'features/restreamer/sagas/onRestreamingStartedSaga';
import { stopRestreamingRequestSaga } from 'features/restreamer/sagas/stopRestreamingRequestSaga';
import { stopRestreamingSaga } from 'features/restreamer/sagas/stopRestreamingSaga';
import { onRestreamingFailureSaga } from 'features/restreamer/sagas/onRestreamingFailureSaga';
import { onRestreamingRequestedSaga } from 'features/restreamer/sagas/onRestreamingRequestedSaga';
import { onRestreamerJoinedSaga } from 'features/restreamer/sagas/onRestreamerJoinedSaga';

export default function* restreamerWatcher() {
  yield takeLatest(restreamingToggled, toggleRestreamingSaga);

  yield takeLatest(requestRestreaming, requestRestreamingSaga);
  yield takeLatest(signalingRestreamingRequested, onRestreamingRequestedSaga);
  yield takeLatest(signalingRestreamingStarted, onRestreamingStartedSaga);

  yield takeLatest(stopRestreamingRequest, stopRestreamingRequestSaga);
  yield takeLatest(signalingRestreamingStopRequested, stopRestreamingSaga);
  yield takeLatest(signalingRestreamingStopped, onRestreamingStoppedSaga);

  yield takeLatest(signalingRestreamingFailure, onRestreamingFailureSaga);

  yield takeLatest(signalingRestreamerJoined, onRestreamerJoinedSaga);
}
